<template>
  <div>
    <SsgMessagebox
      titles="款项金额"
      v-if="maskshow && masktype == 'money'"
      @sub="onmoney"
      @shut="shut"
      width="500px"
      height="auto"
    >
      <div class="mtitle">请填写您收到的款项金额</div>
      <div class="minput">
        <el-input v-model="money" type="number"></el-input>
        <span class="left">￥</span>
        <span class="right">元</span>
      </div>
    </SsgMessagebox>

    <SsgMessagebox
      :titles="!checkval ? '添加合同公司' : '修改合同公司'"
      v-if="maskshow && masktype == 'addcompany'"
      width="566px"
      height="auto"
      @sub="operating"
      @shut="shut"
    >
      <div class="form">
        <!-- <p class="ps" v-if="!checkval">
          请填写您公司的银行对公账户信息，我们将向您公司的账户打一笔随机数额的款项，请将收到的款项数额反馈给我们，以完成身份验证。
        </p> -->
        <el-form
          :model="addForm"
          :rules="rules"
          ref="addForm"
          label-width="130px"
          label-position="right"
        >
          <el-form-item label="公司名称" prop="name" :rules="rules.name">
            <el-input
              v-model="addForm.name"
              placeholder="请输入合同公司名称"
              maxlength="30"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="公司地址" prop="registerAddress">
            <el-input
              v-model="addForm.registerAddress"
              placeholder="请输入合同公司地址"
              maxlength="30"
            ></el-input>
          </el-form-item> -->
          <el-form-item label="联系人名称" prop="linkManName" :rules="rules.linkManName"> 
            <el-input
              v-model="addForm.linkManName"
              placeholder="请输入联系人名称"
              maxlength="30"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系人手机号" prop="linkManMobile" :rules="rules.linkManMobile">
            <el-input
              v-model="addForm.linkManMobile"
              placeholder="请输入联系人手机号"
              maxlength="30"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="合同公司邮箱" prop="companyEmail">
            <el-input
              v-model="addForm.companyEmail"
              placeholder="请输入合同公司邮箱"
              maxlength="30"
            ></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="单位类型" prop="unitType">
            <el-select v-model="addForm.unitType" placeholder="请选择单位类型">
              <el-option label="普通企业" :value="0"></el-option>
              <el-option label="社会团体" :value="1"></el-option>
              <el-option label="事业单位" :value="2"></el-option>
              <el-option label="民办非企业单位" :value="3"></el-option>
              <el-option label="党政及国家机构" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="注册类型" prop="registerType">
            <el-select
              v-model="addForm.registerType"
              placeholder="请选择注册类型"
            >
              <el-option label="代理人注册" :value="1"></el-option>
              <el-option label="法人注册" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="法人归属地" prop="legalPersonPlace">
            <el-select
              v-model="addForm.legalPersonPlace"
              placeholder="请选择法人归属地"
            >
              <el-option label="大陆" :value="0"></el-option>
              <el-option label="香港" :value="1"></el-option>
              <el-option label="澳门" :value="1"></el-option>
              <el-option label="台湾" :value="2"></el-option>
              <el-option label="外籍" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="法人名称" prop="legalPerson">
            <el-input
              v-model="addForm.legalPerson"
              placeholder="请输入法人名称"
              maxlength="20"
            ></el-input>
          </el-form-item>
          <el-form-item label="法人身份证号" prop="legalPersonIdnumber">
            <el-input
              v-model="addForm.legalPersonIdnumber"
              placeholder="请输入法人身份证号"
              maxlength="18"
            ></el-input>
          </el-form-item>
          <el-form-item label="注册号类型" prop="registerNumberType">
            <el-select
              v-model="addForm.registerNumberType"
              placeholder="请选择注册号类型"
            >
              <el-option label="组织机构代码号" :value="0"></el-option>
              <el-option
                label="多证合一，传递社会信用代码号"
                :value="1"
              ></el-option>
              <el-option label="企业工商注册码" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="纳税人识别号" prop="registerNumber">
            <el-input
              v-model="addForm.registerNumber"
              placeholder="请输入纳税人识别号"
            ></el-input>
          </el-form-item>
          <el-form-item label="行业" prop="industry">
            <el-input
              v-model="addForm.industry"
              placeholder="请输入行业"
            ></el-input>
          </el-form-item>
          <el-form-item label="对公银行名称" prop="bank">
            <el-select
              v-model="addForm.bank"
              filterable
              remote
              reserve-keyword
              placeholder="请输入银行名称"
              :remote-method="getBankList"
              :loading="loading"
            >
              <el-option
                v-for="item in bankList"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开户行省份" prop="provice">
            <el-select
              v-model="addForm.provice"
              placeholder="请选择省份"
              @change="getCityList"
            >
              <el-option
                v-for="item in proviceList"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="开户行城市" prop="city">
            <el-select v-model="addForm.city" placeholder="请选择城市">
              <el-option
                v-for="item in cityList"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="银行账户" prop="cardno">
            <el-input
              placeholder="请输入银行账户"
              v-model="addForm.cardno"
            ></el-input>
          </el-form-item>
          <el-form-item class="banker" label="对公银行开户行" prop="subBranch">
            <el-select
              v-model="addForm.subBranch"
              filterable
              allow-create
              remote
              reserve-keyword
              placeholder="请输入银行开户行名称"
              :remote-method="getSubBranchList"
              @change="getPrcptcd"
              :loading="loading"
              clearable

            >
              <el-option
                v-for="item in subBranchList"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="银行支付联行号"
           
            prop="prcptcd"
          >
            <el-input
              placeholder="请输入银行支付联行号"
              v-model="addForm.prcptcd"
            ></el-input>
          </el-form-item> -->
        </el-form>
      </div>
    </SsgMessagebox>
    <SsgMessagebox
      titles="修改认证信息"
      v-if="maskshow && masktype == 'editcompany'"
      width="566px"
      height="auto"
      @sub="editoperating()"
      @shut="shut"
    >
      <div class="form">
      
        <el-form
          :model="editForm"
          :rules="editrules"
          ref="editForm"
          label-width="130px"
          label-position="right"
        >
        
          <el-form-item label="联系人名称" prop="linkManName" :rules="editrules.linkManName"> 
            <el-input
              v-model="editForm.linkManName"
              placeholder="请输入联系人名称"
              maxlength="30"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系人手机号" prop="linkManMobile" :rules="editrules.linkManMobile">
            <el-input
              v-model="editForm.linkManMobile"
              placeholder="请输入联系人手机号"
              maxlength="30"
            ></el-input>
          </el-form-item>

        </el-form>
      </div>
    </SsgMessagebox>
    <div class="authority" v-if="status == true">
      <div class="content">
        <p>您没有权限查看页面</p>
        <p>如需开通请联系系统管理员</p>
      </div>
    </div>
    <div v-else>
      <div class="box">
        <p class="return" @click="back">返回首页</p>
        <span class="line">|</span>
        <p class="contract">系统设置</p>
        <span class="lines">></span>
        <p class="contract back">合同公司</p>
      </div>
      <div class="mainTitle">合同公司</div>

      <div class="p_btn">
        <p>
          合同公司是劳动合同关系的主体单位，是与员工建立劳动法律关系的当事人
        </p>
        <button class="btn subbtn" @click="add">添加合同公司</button>
      </div>
      <div class="table">
        <el-table
          :data="list"
          style="width: 100%"
          :header-cell-style="{ background: '#f8fafb', color: '#303140' }"
        >
          <el-table-column
            label="合同公司名称"
            prop="name"
            min-width="35%"
            align="left"
          >
            <template slot-scope="scope">
              <div style="display: flex; align-items: center">
                {{ scope.row.name }}
                <!-- <div class="default" v-if="scope.row.markDefault == 1">
                  默认
                </div> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column label="认证&授权状态" prop="authzState" min-width="25%">
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.authzState == 1
                "
                class="span_bgc1"
                >未认证</span
              >
              <span
                v-if="scope.row.authzState == 2 && scope.row.expireTime  && !scope.row.willDateTrue "
                class="span_bgc4"
                >已认证</span
              >
              <span
                v-if="scope.row.authzState == 2 && !scope.row.expireTime  && !scope.row.willDateTrue "
                class="span_bgc4"
                >未授权</span
              >
              <span
                v-if="scope.row.authzState == 2 && scope.row.expireTime  && scope.row.willDateTrue "
                class="span_bgc2"
                >授权即将到期</span
              >
              <span class="hove" v-if="(scope.row.authzState == 2 && !scope.row.expireTime) ||(scope.row.authzState == 2 && scope.row.willDateTrue)  " @click="goauth(scope.row,scope.row.id)">去授权</span>

              <span class="hove" v-if="scope.row.authzState == 1" @click="goauth(scope.row,scope.row.id)">去认证</span>
            </template>
          </el-table-column>
          <el-table-column
          label="认证生效时间"
          prop="effectiveTime"
          min-width="20"
          align="left"
        >
          <template slot-scope="scope">
            <span v-if="!scope.row.effectiveTime">-</span>
            <span v-else>{{ scope.row.effectiveTime }}</span>

          </template></el-table-column
        >
        <el-table-column
          label="认证过期时间"
          prop="expireTime"
          min-width="20"
          align="left"
        >
          <template slot-scope="scope"> <span v-if="!scope.row.expireTime">-</span>
            <span v-else>{{ scope.row.expireTime }}</span>
</template>
        </el-table-column>
          <el-table-column
            label="公司印章"
            prop="name1"
            min-width="15%"
            align="left"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.sealTotal > 0">{{
                scope.row.sealTotal
              }}</span>
              <span v-if="!scope.row.sealTotal || scope.row.sealTotal == 0"
                >未设置</span
              >
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="10%" align="center">
            <template slot-scope="scope">
              <el-dropdown placement="bottom" size="small">
                <span class="el-dropdown-link menu">
                  <span></span>
                  <i>操作</i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="seal(scope.row)"
                    >设置印章</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="scope.row.authzState == 1 "
                    @click.native="editupate(scope.row,scope.row.id)"
                    >修改认证信息</el-dropdown-item
                  >
                  <el-dropdown-item
                    :disabled="scope.row.authzState == 2 ? true : false"
                    @click.native="deleteContractCompany(scope.row.id)"
                    >删除</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <page
        :page="pageNum"
        :pagesize.sync="pageSize"
        :total="total"
        @currentChange="cur"
        @enter="cur"
        v-show="total > 0"
        :pageNum="pageNum"
      ></page>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    //初始化数据
    this.loadData();
    this.getProviceList();
    // this.loadcertification();
    const today = new Date();
    // const daysAfter = new Date(today);
    this.nowdate =  today.getTime()
   
  },
  data() {
    // var namerepeat = (rule, value, callback) => {
    //   if (!this.checkval) {
    //     if (this.list.length > 0) {
    //       for (var i = 0; i < this.list.length; i++) {
    //         if (this.list[i].name == value) {
    //           return callback(new Error("公司名称已存在"));
    //         }
    //       }
    //       return callback();
    //     } else {
    //       return callback();
    //     }
    //   } else {
    //     if (this.list.length > 0) {
    //       for (var i = 0; i < this.list.length; i++) {
    //         if (this.list[i].name == value && this.checkkey != i) {
    //           return callback(new Error("公司名称已存在"));
    //         }
    //       }
    //       return callback();
    //     } else {
    //       return callback();
    //     }
    //   }
    // };
    return {
      nowdate:'',
      dateWillTrue:false,
      status: false,
      list: [],
      checkid: "",
      checkval: "",
      editcheckval:'',
      checkkey: "",
      pageNum: 1,
      pageSize: 10,
      total: 0,
      maskshow: false,
      masktype: "",
      id: "",
      company_id: "",
      addForm: {
        // registerType: 2,
        // unitType: 0,
        // legalPersonPlace: 0,
        // registerNumberType: 1,
        // prcptcd:'',
        // city:''
      },
      editForm:{

      },
      editrules: {
        name: [
          {
            required: true,
            message: "请输入合同公司",
            trigger: "blur",
          },
          // {
          //   validator: namerepeat,
          //   message: "公司名称已存在",
          //   trigger: "blur",
          // },
        ],
        linkManName: [
          {
            required: true,
            message: "请输入联系人名称",
            trigger: "blur",
          },
          // {
          //   validator: namerepeat,
          //   message: "公司名称已存在",
          //   trigger: "blur",
          // },
        ],
        linkManMobile: [
          {
            required: true,
            message: "请输入联系人手机号",
            trigger: "blur",
          },
          {
            pattern: /^1[3|4|5|7|8][0-9]\d{8}$/,
            message: "手机号格式不正确",
          },
          // {
          //   validator: namerepeat,
          //   message: "公司名称已存在",
          //   trigger: "blur",
          // },
        ],
          },
      rules: {
        name: [
          {
            required: true,
            message: "请输入合同公司",
            trigger: "blur",
          },
          // {
          //   validator: namerepeat,
          //   message: "公司名称已存在",
          //   trigger: "blur",
          // },
        ],
        linkManName: [
          {
            required: true,
            message: "请输入联系人名称",
            trigger: "blur",
          },
          // {
          //   validator: namerepeat,
          //   message: "公司名称已存在",
          //   trigger: "blur",
          // },
        ],
        linkManMobile: [
          {
            required: true,
            message: "请输入联系人手机号",
            trigger: "blur",
          },
          {
            pattern: /^1[3|4|5|7|8][0-9]\d{8}$/,
            message: "手机号格式不正确",
          },
          // {
          //   validator: namerepeat,
          //   message: "公司名称已存在",
          //   trigger: "blur",
          // },
        ],
      //   legalPerson: [
      //     {
      //       required: true,
      //       message: "请输入法人名称",
      //       trigger: "blur",
      //     },
      //   ],
      //   legalPersonIdnumber: [
      //     {
      //       required: true,
      //       pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
      //       message: "身份证号格式不正确",
      //       trigger: "blur",
      //     },
      //   ],

      //   registerNumber: [
      //     {
      //       required: true,
      //       message: "请输入纳税人识别号",
      //       trigger: "blur",
      //     },
      //   ],

      //   bank: [
      //     {
      //       required: true,
      //       message: "请输入对公银行名称",
      //       trigger: "change",
      //     },
      //   ],

      //   cardno: [
      //     {
      //       required: true,
      //       message: "请输入银行账号",
      //       trigger: "blur",
      //     },
      //   ],

      //   subBranch: [
      //     {
      //       required: true,
      //       message: "请输入对公银行开户行",
      //       trigger: "change",
      //     },
      //   ],

      //   prcptcd: [
      //     	{
      //     	required: true,
      //     	message: '请输入开户行联行号',
      //     	// trigger: 'blur',

		  // },
		  
      //   ],

      //   provice: [
      //     {
      //       required: true,
      //       message: "请选择开户行省份",
      //       trigger: "change",
		  // },
		   
      //   ],

      //   city: [
      //     {
      //       required: true,
      //       message: "请选择开户行城市",
      //     },
      //   ],
      //   unitType: [
      //     {
      //       required: true,
      //       message: "请选择单位类型",
      //       trigger: "change",
      //     },
      //   ],
      //   registerType: [
      //     {
      //       required: true,
      //       message: "请选择注册类型",
      //       trigger: "change",
      //     },
      //   ],
      //   legalPersonPlace: [
      //     {
      //       required: true,
      //       message: "请选择法人归属地",
      //       trigger: "change",
      //     },
      //   ],
      //   registerNumberType: [
      //     {
      //       required: true,
      //       message: "请选择注册号类型",
      //       trigger: "change",
      //     },
      //   ],
      },
      money: "",
      moneyid: "",
      loading: false,
      bankList: [],
      subBranchList: [],
      proviceList: [],
      cityList: [],
      isDisabled: false,
      authzState: "",
      authzEnable: true,
      editId:''
    };
  },
  methods: {
    back() {
      this.$router.push({ path: "/main" });
    },
    editupate(row,id) {
        // 清空表单项
        for (let key in this.editForm) {
        this.editForm[key] = "";
      }
      this.editForm.name = row.name
      this.editId = id
      this.editcheckval = 2
      this.maskshow = true
      this.masktype = 'editcompany'
    },
    goauth(row,id) {
      this.editForm.name = row.name
       this.editId = id
      this.$axios
        .get("/companyContract/auth?id="+id)
        .then((res) => {
          if(res.data.data == false){
             this.editcheckval = 1
             this.maskshow = true
             this.masktype = 'editcompany'
          }else {
            window.open(res.data.data);

          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    loadcertification() {
      this.$axios
        .get("/contractCompany/getDefaultCompanyAuthzState")
        .then((res) => {
          this.authzState = res.data.data.authzState;
          this.authzEnable = res.data.data.authzEnable;
        })
        .catch((err) => {
          console.error(err);
        });
    },

    hqid(id) {
      this.checkid = id;
    },
    lkid() {
      this.checkid = "";
    },
    shut() {
      this.isDisabled = false;
      this.checkval = "";
      this.checkkey = "";
      this.company_id = "";
      this.maskshow = false;
      this.masktype = "";
    },
    // 加载合同公司列表
    loadData() {
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      return this.$axios
        .get("companyContract/list", {
          params,
        })
        .then((res) => {
          if (res.data.status == 2) {
            this.status = true;
          } else {
            this.list = res.data.data.list;
            for (let i = 0; i < this.list.length; i++) {
              this.list[i].willDateTrue = false
              if(this.list[i].expireTime){
               
                let date = new Date(this.list[i].expireTime);
                let givenDate = date.getTime();
                let dateCha =  givenDate -this.nowdate ;
                var days = dateCha / (1000 * 60 * 60 * 24);
              if(days <= 15){
                this.list[i].willDateTrue = true
              }
              console.log(days)
              }
             
              
              
            }
           
            this.total = res.data.data.total;
          }
        })
        .catch((err) => {
          //处理错误
          console.error(err);
        });
    },
    add() {
      this.maskshow = true;
      this.masktype = "addcompany";
      this.subBranchList = [];
      // 清空表单项
      for (let key in this.addForm) {
        this.addForm[key] = "";
      }
    },
        //编辑合同信息
      editContractCompany(row) {
      this.$refs.editForm.validate((status) => {
        if (status == true) {
          this.editForm.id = this.editId;
          return this.$axios
            .post("/companyContract/edit", this.editForm)
            .then((res) => {
              if (res.data.status == 1) {
                this.$message.success(res.data.message);
                this.maskshow = false;
                this.masktype = 'editcompany'
                if(row == 1){
                  this.goauth('',this.editId)
                }

              } else {
                this.$message.error(res.data.message);
              }
            })
            .catch((err) => {
              //处理错误
              console.error(err);
            });
        }
      });
    },
    editoperating() {
      if(this.editcheckval  == 1) {
        this.editContractCompany(1)
      }else if(this.editcheckval  == 2) {
        this.editContractCompany(2)

      }
       
    },
    operating() {
      if (this.checkval) {
        this.updateContractCompany();
      } else {
         for (var i = 0; i < this.list.length; i++) {
            if (this.list[i].name == this.addForm.name) {
              this.$message.error("公司名称已存在");
              return

            }
          }
        this.addContractCompany();
      }
    },

    // 添加合同公司
    addContractCompany() {
      this.$refs.addForm.validate((status) => {
        if (status == true) {
          return this.$axios
            .post("companyContract/add", this.addForm)
            .then((res) => {
              if (res.data.status == 1) {
                this.$message.success(res.data.message);
                this.maskshow = false;
                this.masktype = "";
                this.loadData();
              } else {
                this.$message.error(res.data.message);
              }
            })
            .catch((err) => {
              //处理错误
              console.error(err);
            });
        }
      });
    },

    //修改
    updateContractCompany() {
      this.$refs.addForm.validate((status) => {
        if (status == true) {
          this.addForm.id = this.checkval;
          return this.$axios
            .post("companyContract/update", this.addForm)
            .then((res) => {
              if (res.data.status == 1) {
                this.$message.success(res.data.message);
                this.maskshow = false;
                this.loadData();
              } else {
                this.$message.error(res.data.message);
              }
            })
            .catch((err) => {
              //处理错误
              console.error(err);
            });
        }
      });
    },

    update(val, k) {
      var obj = {};
      obj.id = val.id;
      this.$axios
        .post("companyContract/resetAuthStatus", obj)
        .then((res) => {
          if (res.data.status == 1) {
            this.$axios
              .get("companyContract/find?id=" + val.id)
              .then((res1) => {
                if (res1.data.status == 1) {
                  var data = res1.data.data;
                  this.addForm = data;

                  this.checkval = val.id;
                  this.checkkey = k;
                  this.maskshow = true;
                  this.masktype = "addcompany";
                } else {
                  this.$message.error(res.data.message);
                }
              })
              .catch((err1) => {
                //处理错误
                console.error(err1);
              });
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          //处理错误
          console.error(err);
        });
    },

    // 删除合同公司
    deleteContractCompany(id) {
      this.$confirm(
        '<p style="margin-bottom:10px">删除后不可恢复，确定删除所选合同？</p>',
        "删除合同",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          type: "warning",
        }
      )
        .then(() => {
          const params = {
            id: id,
          };
          this.$axios
            .delete("companyContract/delete/" + params.id, {})
            .then((res) => {
              this.$message.success(res.data.message);
              this.pageNum = 1;
              this.loadData();
            });
        })
        .catch((err) => {
          //处理错误
          console.error(err);
        });
    },
    //分页方法
    cur(val) {
      this.pageNum = val;
      this.loadData();
    },
    search() {
      this.pageNum = 1;
      this.loadData();
    },
    seal(val) {
      if (val.authzState == 2 ) {
        this.$router.push({
          path: "contractCompany/seal",
          query: {
            id: val.orgId,
           company_id:val.id
          },
        });
      } else {
        this.$message({
          message: "无法设置公司印章，请先完成合同公司的认证",
          type: "warning",
        });
      }
    },

    onmoney() {
      if (this.money) {
        const params = {};
        params.id = this.moneyid;
        params.cash = this.money;
        this.$axios.post("/companyContract/validCash", params).then((res) => {
          if (res.data.status == 1) {
            this.$message.success("提交款项成功");
            this.shut();
            this.loadData();
          } else {
            this.$message.error(res.data.message);
          }
        });
      } else {
        this.$message.warning("请填写您收到的款项金额");
      }
    },

    addmoney(id) {
      this.moneyid = id;
      this.maskshow = true;
      this.masktype = "money";
    },

    getBankList(query) {
      console.log(query);
      if (query !== "") {
        this.loading = true;
        this.$axios
          .get("/companyContract/getBankList?name=" + query)
          .then((res) => {
            if (res.data.status == 1) {
              this.loading = false;
              this.bankList = res.data.data;
            }
          });
      } else {
        this.bankList = [];
      }
    },

    getSubBranchList(query) {
      if (query !== "") {
        this.loading = true;
        this.$axios
          .get("/companyContract/getBankBList?name=" + query, {})
          .then((res) => {
            if (res.data.status == 1) {
              this.loading = false;
              this.subBranchList = res.data.data;
            }
          });
      } else {
        this.subBranchList = [];
      }
    },

    getPrcptcd(query) {
      if (query !== "") {
        this.addForm.prcptcd = ''
        this.loading = true;
        return this.$axios
          .get("/companyContract/getBankPrcptcd?name=" + query, {})
          .then((res) => {
            if (res.data.status == 1) {
              this.loading = false;
              if (res.data.data != null) {
                this.isDisabled = true;
                this.addForm.prcptcd = res.data.data;
                console.log(this.addForm.prcptcd);
              } else {
                this.isDisabled = false;
                this.addForm.prcptcd = "";
              }
            }
          });
      } else {
        this.addForm.prcptcd = "";
      }
    },

    getCityList() {
      this.addForm.city = ''
      return this.$axios
        .get("/companyContract/getBankCList?provice=" + this.addForm.provice)
        .then((res) => {
          if (res.data.status == 1) {
            console.log(res);
            this.cityList = res.data.data;
          }
        });
    },

    getProviceList() {
      this.$axios.get("/companyContract/getBankPList").then((res) => {
        if (res.data.status == 1) {
          this.proviceList = res.data.data;
        }
      });
    },
    onAuthzShow(data) {
      let n = false;
      if (this.authzEnable) {
        if (data.authzState == 2 || data.markDefault == 1) {
          n = true;
        }
      } else {
        n = true;
      }
      return n;
    },
  },
  // watch: {
  // 	pageNum: function(val, oldVal) {
  // 		this.$refs.page.page = val;
  // 	}
  // }
};
</script>

<style src="../../../assets/css/common/nav.less" scoped lang="less"></style>
<style src="../../../assets/css/common/table.less" scoped lang="less"></style>
<style scoped lang="less">
.mainTitle {
  font-size: 24px;
  font-weight: bold;
  color: rgba(48, 49, 64, 1);
  margin: 33px 0 14px 0;
}
.box {
  display: flex;
  margin-top: 20px;

  .return {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 105, 227, 1);
    margin-right: 20px;
    cursor: pointer;
  }

  .line {
    margin-right: 20px;
    color: #606266;
  }

  .lines {
    margin-right: 20px;
    color: #606266;
    font-weight: bold;
  }

  .back:hover {
    color: #6669e3;
    cursor: pointer;
  }

  .contract {
    margin-right: 20px;
    font-size: 12px;
    font-weight: 400;
    color: rgba(138, 138, 154, 1);
  }
}
.tab_nav {
  border-bottom: none;
}

.form {
  margin: 23px 0;
}

.ps {
  width: 100%;
  padding: 10px 0 35px 10px;
  box-sizing: border-box;
  font-size: 12px;
  font-weight: bold;
  color: #555663;
}

.el-form-item {
  margin-bottom: 15px;
}

.span_bgc {
  padding: 3px 5px;
  background-color: #ccc9c9;
  color: #fff;
  border-radius: 4px;
}

.span_bgc1 {
  padding: 3px 5px;
  background-color: #ff6752;
  color: #fff;
  border-radius: 4px;
}

.span_bgc2 {
  padding: 3px 5px;
  background-color: #f6d703;
  color: #fff;
  border-radius: 4px;
}

.span_bgc3 {
  padding: 3px 5px;
  background-color: #ff6161;
  color: #fff;
  border-radius: 4px;
}

.span_bgc4 {
  padding: 3px 5px;
  background-color: #3bc798;
  color: #fff;
  border-radius: 4px;
}

.default {
  color: #6669e3;
  height: 20px;
  border: 1px solid #6669e3;
  padding: 0 5px;
  border-radius: 2px;
  margin-left: 10px;
  display: flex;
  align-items: center;
}

.hove {
  color: #8285ff;
  cursor: pointer;
  margin-left: 10px;
}

.mtitle {
  width: 100%;
  margin: 40px 0 20px;
  font-size: 14px;
}

.minput {
  margin-bottom: 48px;
  position: relative;

  .left {
    top: 6px;
    left: 10px;
    font-size: 14px;
    position: absolute;
  }

  .right {
    top: 6px;
    right: 12px;
    font-size: 14px;
    position: absolute;
  }
}

.minput /deep/ .el-input__inner {
  padding: 0 30px;
}

.form /deep/ .el-select {
  width: 100%;
}
.authority {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  margin: 100px auto;

  .content {
    text-align: center;
    margin: 50px auto;
    font-size: 24px;
    font-weight: bold;
    color: #303140;
  }
}
.banker /deep/ .el-select .el-input .el-select__caret {
    color: #C0C4CC;
    font-size: 14px;
    transition: transform .3s;
    transform: rotateZ(0deg);
    cursor: pointer;
    margin-right: -20px;
}
</style>
